import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SideCol from '../components/SideCol';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const response = await fetch('https://trinoxabrasives.com/api/inquiry/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        full_name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message
      })
    });
    console.log(response)

    const result = await response.json();

    if (response.ok && result.status === "success") {
      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      // Hide success message after 3 seconds
      setTimeout(() => setSubmitSuccess(false), 3000);
    } else {
      alert('Failed to send message. Please try again.');
    }
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('An error occurred. Please try again.');
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div className="contact-page">
      <Header />
      
      {/* Contact Us */}
      <div className="contact-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-7">
              <div className="section-heading text-center">
                <h6 className="section-subtitle">| Contact Us</h6>
                <h2 className="section-title">Get In Touch With Our Team</h2>
                <p className="section-description">
                  Have questions or need assistance? Reach out to us and we'll get back to you promptly.
                </p>
                <hr className="mx-auto" style={{width: '80px', borderTop: '2px solid rgba(11,119,65,255)'}}></hr>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Contact Content */}
      <div className="contact-content">
        <div className="container">
          <div className="row g-5">
            {/* Contact Info Column */}
            <div className="col-lg-6">
              <div className="contact-info-card">
                <div className="contact-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5569635005872!2d78.48449148237705!3d17.43303656823308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9a1bf7cf46e3%3A0xa43867837e5891d4!2sBurhani%20Traders!5e0!3m2!1sen!2sin!4v1757768516630!5m2!1sen!2sin"
                    width="100%"
                    height="400"
                    style={{ border: 0, borderRadius: '12px' }}
                    allowFullScreen=""
                    loading="lazy"
                    title="Location Map"
                  ></iframe>
                </div>

                <div className="contact-details mt-5">
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="detail-card phone">
                        <div className="detail-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                          </svg>
                        </div>
                        <div className="detail-content">
                          <h5>Phone Number</h5>
                          <p>088856 56752</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="detail-card email">
                        <div className="detail-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                          </svg>
                        </div>
                        <div className="detail-content">
                          <h5>Business Email</h5>
                          <p><small>burhaniabron@gmail.com</small></p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="detail-card address">
                        <div className="detail-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                          </svg>
                        </div>
                        <div className="detail-content">
                          <h5>Office Location</h5>
                          <p>60/A/2 (2-2-103 to 108) Rani Gunj 'X' Road, Secunderabad, Telangana 500003</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="detail-card hours">
                        <div className="detail-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg>
                        </div>
                        <div className="detail-content">
                          <h5>Working Hours</h5>
                          <p>Mon-Sat: 10AM - 8PM</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form Column */}
            <div className="col-lg-6">
              <div className="contact-form-card">
                <h3 className="form-title">Send Us a Message</h3>
                <p className="form-subtitle">We'll respond within 24 hours</p>
                
                {submitSuccess && (
                  <div className="alert alert-success" role="alert">
                    Thank you! Your message has been sent successfully.
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Full Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="John Doe"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="your.email@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      placeholder="How can we help?"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Your Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      placeholder="Write your message here..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className="submit-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <SideCol />
    </div>
  );
};

export default Contact;